
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9EfFC", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $893da78086ca16ac$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $893da78086ca16ac$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dOMrE = parcelRequire("dOMrE");

var $i0btU = parcelRequire("i0btU");

var $4qXXo = parcelRequire("4qXXo");

var $l2474 = parcelRequire("l2474");

var $6mYMS = parcelRequire("6mYMS");

var $3jsXx = parcelRequire("3jsXx");

var $1DWH0 = parcelRequire("1DWH0");

var $28cxD = parcelRequire("28cxD");

var $bwC67 = parcelRequire("bwC67");

var $g6YCz = parcelRequire("g6YCz");
const $893da78086ca16ac$export$7452d7062a4d0634 = 1000;
const $893da78086ca16ac$export$af8124aa496797f2 = '_|unknown|_';
class $893da78086ca16ac$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    componentDidMount() {
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $28cxD.UFOExperienceState)['STARTED'],
            (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwC67.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$893da78086ca16ac$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $6mYMS.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dOMrE.default), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4qXXo.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g6YCz.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i0btU.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l2474.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $893da78086ca16ac$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $6mYMS.MentionType).SELF;
            if ((0, $6mYMS.isRestricted)(accessLevel)) return (0, $6mYMS.MentionType).RESTRICTED;
            return (0, $6mYMS.MentionType).DEFAULT;
        };
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $893da78086ca16ac$var$MentionWithAnalytics = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($893da78086ca16ac$export$92ab8442e7a15cef);
const $893da78086ca16ac$var$Mention = $893da78086ca16ac$var$MentionWithAnalytics;
var $893da78086ca16ac$export$2e2bcd8739ae039 = $893da78086ca16ac$var$Mention;

});
parcelRegister("i0btU", function(module, exports) {

$parcel$export(module.exports, "default", () => $806263e9564ebacc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");
var $dBxQj = parcelRequire("dBxQj");

var $bwC67 = parcelRequire("bwC67");
const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $dBxQj.default)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;

});
parcelRegister("bwC67", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $1cb8431546098045$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $1cb8431546098045$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $1cb8431546098045$export$da9f8ce14593162f);
$parcel$export(module.exports, "DefaultHeadline", () => $1cb8431546098045$export$4a258ffee7316766);
$parcel$export(module.exports, "DefaultAdvisedAction", () => $1cb8431546098045$export$702321a50d74536e);
$parcel$export(module.exports, "LoginAgain", () => $1cb8431546098045$export$ed7f16088a93ae9d);
$parcel$export(module.exports, "DifferentText", () => $1cb8431546098045$export$3ab158df56460d1c);
$parcel$export(module.exports, "getMessagesForLocale", () => $1cb8431546098045$export$d0a3169680473b6c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $gjAAG = parcelRequire("gjAAG");
const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $dBxQj.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("cHtEA")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("kYvyU")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("3rTFz")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("amhIJ")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("8cN5M")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("lhchK")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("5TI31")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("8qBjl")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("2lyk6")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("aFxir")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("jIHc6")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("iAcm7")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("7LxwD")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5iEZp")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4Lc6F")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("jFOrX")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("Z6SDd")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("e5oL3")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("3wM1g")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("baosp")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("f1pOX")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("27l7W")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dMmE3")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("duJJs")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("hZCgX")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("gGmca")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("3ubWl")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("f2f1r")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("dHHk2")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("5BFfE")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("amhIJ")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("gjAAG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $898c0db98da1400a$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $898c0db98da1400a$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});

});

parcelRegister("cHtEA", function(module, exports) {

let $93f080c97bc67f0a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $93f080c97bc67f0a$var$load("5Pnad").then(()=>parcelRequire('6Yuab'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("kYvyU", function(module, exports) {

let $f451e4d1425dc0ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f451e4d1425dc0ef$var$load("3qzeo").then(()=>parcelRequire('biDFC'));

});

parcelRegister("3rTFz", function(module, exports) {

let $282f137e3bbc62e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $282f137e3bbc62e5$var$load("4UYlu").then(()=>parcelRequire('e7zr1'));

});

parcelRegister("amhIJ", function(module, exports) {

let $78a9b4655d1a6bb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $78a9b4655d1a6bb6$var$load("3qbnQ").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("8cN5M", function(module, exports) {

let $5f95866a0d515935$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5f95866a0d515935$var$load("HY4Vc").then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("lhchK", function(module, exports) {

let $f7d4b714fc9b340d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7d4b714fc9b340d$var$load("fJQPR").then(()=>parcelRequire('4FRcU'));

});

parcelRegister("5TI31", function(module, exports) {

let $44b441bfa2aee5cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $44b441bfa2aee5cf$var$load("gxipV").then(()=>parcelRequire('bG4aH'));

});

parcelRegister("8qBjl", function(module, exports) {

let $622db1a01d34260d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $622db1a01d34260d$var$load("3uZ1q").then(()=>parcelRequire('kVRsY'));

});

parcelRegister("2lyk6", function(module, exports) {

let $1b582acfad5d89c6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1b582acfad5d89c6$var$load("ardvv").then(()=>parcelRequire('FrZOj'));

});

parcelRegister("aFxir", function(module, exports) {

let $7c478fac5a895d65$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c478fac5a895d65$var$load("cjhdF").then(()=>parcelRequire('225Fx'));

});

parcelRegister("jIHc6", function(module, exports) {

let $e5b3a1da0ad9ac72$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5b3a1da0ad9ac72$var$load("2mWUI").then(()=>parcelRequire('alG1N'));

});

parcelRegister("iAcm7", function(module, exports) {

let $d8752c6621b71fea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d8752c6621b71fea$var$load("29Sce").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("7LxwD", function(module, exports) {

let $5a76eda6816639e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5a76eda6816639e5$var$load("dBvXj").then(()=>parcelRequire('gSUUF'));

});

parcelRegister("5iEZp", function(module, exports) {

let $3dbe6dd9a4beb99e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3dbe6dd9a4beb99e$var$load("gmdLX").then(()=>parcelRequire('cF55v'));

});

parcelRegister("4Lc6F", function(module, exports) {

let $3774f1500208ca94$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3774f1500208ca94$var$load("fcXn9").then(()=>parcelRequire('4IbNl'));

});

parcelRegister("jFOrX", function(module, exports) {

let $e528faf41a995a49$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e528faf41a995a49$var$load("lH0NU").then(()=>parcelRequire('jKge3'));

});

parcelRegister("Z6SDd", function(module, exports) {

let $0b7b08dffb504888$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b7b08dffb504888$var$load("3OEsN").then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("e5oL3", function(module, exports) {

let $a414bcba2b589741$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a414bcba2b589741$var$load("hGLdi").then(()=>parcelRequire('d7PIu'));

});

parcelRegister("3wM1g", function(module, exports) {

let $29199bea97a19505$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29199bea97a19505$var$load("Xi5AP").then(()=>parcelRequire('jwd3r'));

});

parcelRegister("baosp", function(module, exports) {

let $8213999802e296ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8213999802e296ce$var$load("f7XHA").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("f1pOX", function(module, exports) {

let $aefafa8284dac4e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aefafa8284dac4e4$var$load("14AZs").then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("27l7W", function(module, exports) {

let $18ac9f9efec4e409$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $18ac9f9efec4e409$var$load("lsFbX").then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dMmE3", function(module, exports) {

let $a08152e7b9674310$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a08152e7b9674310$var$load("ibz6c").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("duJJs", function(module, exports) {

let $9d318d2aa0ecee04$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9d318d2aa0ecee04$var$load("7I8FK").then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("hZCgX", function(module, exports) {

let $d195d246ee99be1e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d195d246ee99be1e$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("gGmca", function(module, exports) {

let $c251c919f6bc9a34$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c251c919f6bc9a34$var$load("4iSRl").then(()=>parcelRequire('4dnaM'));

});

parcelRegister("3ubWl", function(module, exports) {

let $289d6f78ef0283da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $289d6f78ef0283da$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("f2f1r", function(module, exports) {

let $af22b20c9ba5a60e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af22b20c9ba5a60e$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("dHHk2", function(module, exports) {

let $9fa0e568a8bcc90e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9fa0e568a8bcc90e$var$load("7yGIa").then(()=>parcelRequire('lRTsu'));

});

parcelRegister("5BFfE", function(module, exports) {

let $4150681bfb6d7ad4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4150681bfb6d7ad4$var$load("dZksg").then(()=>parcelRequire('jKBtA'));

});



parcelRegister("4qXXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1278ab3a4b348f22$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $6fnsQ = parcelRequire("6fnsQ");

var $6mYMS = parcelRequire("6mYMS");

var $gwFzn = parcelRequire("gwFzn");
const $1278ab3a4b348f22$var$mentionStyle = {
    [(0, $6mYMS.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $6fnsQ.B400)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $6fnsQ.N20)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $6fnsQ.B400)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $6fnsQ.B400)})`
    },
    [(0, $6mYMS.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $6fnsQ.N500)})`,
        text: `var(--ds-text, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $6mYMS.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30A)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30A)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $6fnsQ.N30A)})`
    }
};
const $1278ab3a4b348f22$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $1278ab3a4b348f22$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $1278ab3a4b348f22$var$PrimitiveMention = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3jLHL.css)`
					display: inline;
					border: 1px solid ${$1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'borderColor')};
					background: ${$1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'background')};
					color: ${$1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'text')};
					border-radius: 20px;
					cursor: pointer;
					padding: 0 0.3em 2px 0.23em;
					line-height: 1.714;
					font-size: 1em;
					font-weight: ${"var(--ds-font-weight-regular, 400)"};
					word-break: break-word;
					&:hover {
						background: ${$1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground')};
					}
					&:active {
						background: ${$1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground')};
					}
				`,
        ...other
    });
});
var $1278ab3a4b348f22$export$2e2bcd8739ae039 = $1278ab3a4b348f22$var$PrimitiveMention;

});

parcelRegister("l2474", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23df821b2d2d994$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("9P4pK")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;

});
parcelRegister("9P4pK", function(module, exports) {

let $726c4d15dd63adf2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $726c4d15dd63adf2$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});


parcelRegister("g6YCz", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $af19f55bb4052571$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $af19f55bb4052571$export$5ef1c2550074a375);

var $gwFzn = parcelRequire("gwFzn");

var $9801n = parcelRequire("9801n");
var $iqaft = parcelRequire("iqaft");
const $af19f55bb4052571$export$1d011e4240507c78 = new (0, $9801n.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
class $af19f55bb4052571$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidCatch() {
        $af19f55bb4052571$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});



//# sourceMappingURL=mention.8ae8ef1e.js.map
